import React, { useEffect, useState } from "react";
import * as ST from "./styled";
import { useDispatch } from "react-redux";
import { materialEventsApi } from "src/business.InterfaceLayer/store/entities/materialEvents.entity/materialEventsAPI";
import type { AppDispatch } from "src/business.InterfaceLayer/store";

import { Box, Checkbox, LinearProgress, Typography } from "@mui/material";
import { ReactComponent as ImportIcon } from "src/general/constants/icons/import.svg";
import { ReactComponent as ArrowLeftIcon } from "src/general/constants/icons/arrowLeft.svg";
import { ReactComponent as ArrowRightIcon } from "src/general/constants/icons/arrowRight.svg";
import { ReactComponent as LessonLockIcon } from "src/general/constants/icons/lock.svg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Colors from "src/general/constants/colors";
import CheckIcon from "@mui/icons-material/Check";
import {
	useGetMaterialEventsQuery,
	useUpdateMaterialEventsMutation,
} from "src/business.InterfaceLayer/store/entities/materialEvents.entity/materialEventsAPI";
import {
	formatDateToUTC,
	formatDateAndTimeToUTC,
} from "src/business.InterfaceLayer/store/services/formatDateToUTC";
import {
	Link,
	useNavigate,
	useParams,
	useSearchParams,
} from "react-router-dom";
import {
	Lesson,
	PrivateLesson,
} from "src/business.InterfaceLayer/store/entities/materialEvents.entity/types/types";
import BreakPoints from "src/general/constants/breakPoints";

const MaterialUser = (): JSX.Element | null => {
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();
	const idLesson = Number(useParams().id);

	const {
		data: dataGetMaterialEvents,
		error: errorGetMaterialEvents,
		isLoading: isLoadingGetMaterialEvents,
		refetch,
	} = useGetMaterialEventsQuery(idLesson);
	const [
		updateMaterialEvents,
		{ data: dataUpdateMaterialEvents, isLoading: isUpdatingMaterialEvents },
	] = useUpdateMaterialEventsMutation();

	useEffect(() => {
		if (
			errorGetMaterialEvents &&
			"status" in errorGetMaterialEvents &&
			errorGetMaterialEvents.status === 400
		) {
			navigate("/lk/materials", { replace: true });
		}
	}, [errorGetMaterialEvents, navigate]);

	//для обновления галочки выполненого урока
	const [localLessons, setLocalLessons] = useState<Lesson[]>([]);
	const [localPrivateLessons, setLocalPrivateLessons] = useState<
		PrivateLesson[]
	>([]);
	useEffect(() => {
		if (dataGetMaterialEvents) {
			setLocalLessons(dataGetMaterialEvents.lessons);
			setLocalPrivateLessons(dataGetMaterialEvents.privateAccessLessons);
		}
	}, [dataGetMaterialEvents]);

	//всего активных уроков
	const activeLessons =
		dataGetMaterialEvents?.lessons.filter((lesson) => lesson.active) || [];
	//всего выполненых уроков
	const endLessons =
		dataGetMaterialEvents?.lessons.filter((lesson) => lesson.isDone) || [];
	//последний активный урок
	// const lastActiveLesson =
	// 	activeLessons.length > 0
	// 		? activeLessons.indexOf(activeLessons.at(-1)!)
	// 		: null;
	/////////////////////////выбранный урок - для показа в видеоплитке
	const [currentLessonIndex, setCurrentLessonIndex] = useState<number | null>(
		0
	);
	const [currentPrivateLessonIndex, setCurrentPrivateLessonIndex] = useState<
		number | null
	>(null);

	// useEffect(() => {
	// 	if (lastActiveLesson !== null && currentLessonIndex === null) {
	// 		setCurrentLessonIndex(lastActiveLesson);
	// 	}
	// }, [lastActiveLesson]);

	useEffect(() => {
		if (currentLessonIndex === null) {
			setCurrentLessonIndex(0);
		}
	}, []);

	// выбранный в списке урок - для проброса в видеоплитку
	const selectedLessonVideo =
		currentPrivateLessonIndex !== null &&
		dataGetMaterialEvents?.privateAccessLessons
			? localPrivateLessons[currentPrivateLessonIndex]
			: currentLessonIndex !== null && localLessons.length > currentLessonIndex
			? localLessons[currentLessonIndex]
			: null;

	/////////////////статус закрытого доступа к урокам
	const isAccessVipLesson =
		!!dataGetMaterialEvents?.privateAccessLessons.length;

	///////////////////////////////////фильтр уроков
	const [filter, setFilter] = useState<"all" | "done" | "notDone">("all");
	const filteredLessons =
		dataGetMaterialEvents?.lessons.filter((lesson) => {
			if (filter === "done") return lesson.isDone;
			if (filter === "notDone") return !lesson.isDone;
			return true;
		}) || [];
	const filteredPrivateLessons =
		dataGetMaterialEvents?.privateAccessLessons.filter((privateLesson) => {
			if (filter === "done") return privateLesson.isDone;
			if (filter === "notDone") return !privateLesson.isDone;
			return true;
		}) || [];

	//расчёт процентов прогрессбара
	const totalLessons = dataGetMaterialEvents?.lessons.length || 1;
	const allEndLessons = endLessons.length || 0;
	const progressPercentage = Math.round((allEndLessons / totalLessons) * 100);

	// аттестация
	const hasAttestation = !!dataGetMaterialEvents?.test.link;
	const attestationCompleted = dataGetMaterialEvents?.test.passed;
	const attestationLink = dataGetMaterialEvents?.test.link;

	////////////////////////////функции кнопок
	const handleClickLesson = (
		event: React.MouseEvent<HTMLDivElement>,
		index: number,
		isPrivate: boolean
	) => {
		if (isPrivate) {
			setCurrentPrivateLessonIndex(index);
			setCurrentLessonIndex(null);
		} else {
			setCurrentLessonIndex(index);
			setCurrentPrivateLessonIndex(null);
		}
	};

	const handleDownloadLesson = (fileUrl: string) => {
		if (!fileUrl) return;
		window.open(fileUrl, "_blank");
	};

	//сохранение Выполнение урока
	const handleToggleIsDone = async () => {
		if (!selectedLessonVideo || !dataGetMaterialEvents) return;

		const newIsDone = !selectedLessonVideo.isDone;

		try {
			const updatedData = await updateMaterialEvents({
				id: dataGetMaterialEvents.id,
				lessonId: selectedLessonVideo.id ?? 0,
				isDone: newIsDone,
			}).unwrap();

			setLocalLessons(updatedData.lessons);
			setLocalPrivateLessons(updatedData.privateAccessLessons);

			dispatch(
				materialEventsApi.util.updateQueryData(
					"getMaterialEvents",
					idLesson,
					(draft) => {
						draft.lessons = updatedData.lessons;
						draft.privateAccessLessons = updatedData.privateAccessLessons;
					}
				)
			);
		} catch (error) {
			console.error("Ошибка обновления", error);
		}
	};

	/////////////////////////////кнопки переключения для открытых и закрытых уроков
	const handlePrevLesson = () => {
		if (currentPrivateLessonIndex !== null) {
			if (currentPrivateLessonIndex > 0) {
				setCurrentPrivateLessonIndex((prev) => prev! - 1);
			}
		} else if (currentLessonIndex !== null) {
			if (currentLessonIndex > 0) {
				setCurrentLessonIndex((prev) => prev! - 1);
			}
		}
	};

	const handleNextLesson = () => {
		if (currentPrivateLessonIndex !== null) {
			if (
				currentPrivateLessonIndex < localPrivateLessons.length - 1 &&
				localPrivateLessons[currentPrivateLessonIndex + 1].active
			) {
				setCurrentPrivateLessonIndex((prev) => prev! + 1);
			}
		} else if (currentLessonIndex !== null) {
			if (
				currentLessonIndex < localLessons.length - 1 &&
				localLessons[currentLessonIndex + 1].active
			) {
				setCurrentLessonIndex((prev) => prev! + 1);
			}
		}
	};

	const prevLessonIsActive =
		(currentPrivateLessonIndex !== null && currentPrivateLessonIndex > 0) ||
		(currentLessonIndex !== null && currentLessonIndex > 0);

	const nextLessonIsActive =
		(currentPrivateLessonIndex !== null &&
			currentPrivateLessonIndex < localPrivateLessons.length - 1 &&
			localPrivateLessons[currentPrivateLessonIndex + 1].active) ||
		(currentLessonIndex !== null &&
			currentLessonIndex < localLessons.length - 1 &&
			localLessons[currentLessonIndex + 1].active);

	/////////////////////фильтр уроков
	const handleFilterChange = (newFilter: "all" | "done" | "notDone") => {
		setFilter(newFilter);
	};

	// console.log("dataGetMaterialEvents", dataGetMaterialEvents);
	// console.log(selectedLessonVideo);
	return dataGetMaterialEvents ? (
		<ST.MaterialEventContainer id="MaterialEvent">
			<ST.MaterialLinks id="MaterialLinks_Tile">
				{dataGetMaterialEvents?.links.map((link) => (
					<ST.StyledA
						href={link.url}
						target="_blank"
						rel="noopener noreferrer"
						key={link.url}
					>
						<ST.TicTac>
							<span dangerouslySetInnerHTML={{ __html: link.icon }} />
							<Typography variant="caption">{link.name}</Typography>
						</ST.TicTac>
					</ST.StyledA>
				))}
			</ST.MaterialLinks>

			<ST.VideoAndInfoContainer>
				{/* показывается на 320-768 */}
				<ST.res320_768Add>
					<ST.VideoModule>
						<ST.TitleContainer>
							<ST.InfoTitle id="badge module">
								<Typography
									variant="h5"
									sx={{ color: Colors.BLUE_015 }}
								>
									{dataGetMaterialEvents?.name}
								</Typography>
							</ST.InfoTitle>

							<ST.Baydges id="znachki">
								{dataGetMaterialEvents?.badges.map((badge) => (
									<ST.Baydge color={badge.color}>
										<Typography variant="body1">{badge.name}</Typography>
									</ST.Baydge>
								))}
							</ST.Baydges>
						</ST.TitleContainer>

						<ST.NameModule id={"NameModule"}>
							<Typography variant="body1">
								{dataGetMaterialEvents?.description}
							</Typography>
						</ST.NameModule>
						<Typography
							variant="subtitle2"
							sx={{ color: Colors.BLUE_015 }}
						>
							Доступ до: {formatDateToUTC(dataGetMaterialEvents?.accessDate)}
						</Typography>

						<ST.LineStrix />

						<ST.ProgressBar id="ProgressBar">
							<ST.TitleProgressBarContainer>
								<ST.TitleRowContainer>
									<Typography variant="body2">Пройдено уроков</Typography>
									<Typography
										variant="subtitle2"
										sx={{ color: Colors.GREEN }}
									>
										&nbsp;{allEndLessons} из {totalLessons}
									</Typography>
								</ST.TitleRowContainer>
							</ST.TitleProgressBarContainer>
							<Box sx={{ width: "100%", mt: 1, position: "relative" }}>
								<LinearProgress
									variant="determinate"
									value={progressPercentage}
									sx={{
										height: "20px",
										borderRadius: "4px",
										position: "relative",
									}}
								/>
								<Typography
									variant="subtitle2"
									sx={{
										color: Colors.WHITE,
										position: "absolute",
										top: "50%",
										left:
											progressPercentage === 0
												? `24px`
												: `${progressPercentage}%`,
										transform: "translate(-100%, -50%)",
										paddingRight: progressPercentage === 0 ? "0px" : "8px",
									}}
								>
									&nbsp;{progressPercentage}%
								</Typography>
							</Box>
						</ST.ProgressBar>
					</ST.VideoModule>
				</ST.res320_768Add>

				<ST.VideoContainer>
					{selectedLessonVideo?.materials.video ? (
						<ST.VideoModule id="VideoTile">
							<ST.VideoWrapper
								dangerouslySetInnerHTML={{
									__html: selectedLessonVideo?.materials.video || "",
								}}
							/>
							<ST.Title>
								<ST.RectangleIcon />
								<ST.StyledTypography variant="h5">
									{selectedLessonVideo?.name}
								</ST.StyledTypography>
							</ST.Title>
						</ST.VideoModule>
					) : (
						<ST.VideoModule id="VideoTile">
							<ST.Title>
								<ST.RectangleIcon />
								<ST.StyledTypography variant="h5">
									{selectedLessonVideo?.name}
								</ST.StyledTypography>
							</ST.Title>
						</ST.VideoModule>
					)}
					{/* один материал для скачивания к видео */}
					{selectedLessonVideo &&
						Array.isArray(selectedLessonVideo?.materials.downloads) &&
						selectedLessonVideo.materials.downloads.length > 0 && (
							<ST.VideoModule id="VideoDownload_Tile">
								<ST.DownloadPDF>
									<ST.StyledTypography variant="h5">
										{selectedLessonVideo?.materials.downloads[0].name}
									</ST.StyledTypography>

									<ST.Title>
										<Typography variant="body1">
											{selectedLessonVideo?.materials.downloads[0].size}
										</Typography>
										<ImportIcon
											onClick={() => {
												const url =
													selectedLessonVideo?.materials.downloads[0].url;
												if (url) {
													handleDownloadLesson(url);
												}
											}}
										/>
									</ST.Title>
								</ST.DownloadPDF>
							</ST.VideoModule>
						)}
					<ST.Title>
						<ST.GreenCheckbox
							key={selectedLessonVideo?.name}
							checked={selectedLessonVideo?.isDone}
							onChange={handleToggleIsDone}
						/>
						<Typography variant="body2">Я изучил материал</Typography>
					</ST.Title>

					<ST.LeftRightButtons>
						<ST.LeftRightButton
							onClick={handlePrevLesson}
							disabled={currentLessonIndex === 0}
							isActiveList={prevLessonIsActive}
						>
							<ArrowBackIcon
								sx={{
									color: prevLessonIsActive ? Colors.GREEN : Colors.GREY,
									transform: "scaleX(1.2)",
								}}
							/>
							<Typography
								variant="body1"
								sx={{
									color: prevLessonIsActive ? Colors.GREEN : Colors.GREY,
									"&::after": {
										content: `" урок"`,
									},
									[`@media (max-width:${BreakPoints.MOBILE_767}px)`]: {
										"&::after": {
											content: '""',
										},
									},
								}}
							>
								Предыдущий
							</Typography>
						</ST.LeftRightButton>
						<ST.LeftRightButton
							onClick={handleNextLesson}
							disabled={!nextLessonIsActive}
							isActiveList={nextLessonIsActive}
						>
							<Typography
								variant="body1"
								sx={{
									color: nextLessonIsActive ? Colors.GREEN : Colors.GREY,
									"&::after": {
										content: `" урок"`,
									},
									[`@media (max-width:${BreakPoints.MOBILE_767}px)`]: {
										"&::after": {
											content: '""',
										},
									},
								}}
							>
								Следующий
							</Typography>
							<ArrowForwardIcon
								sx={{
									color: nextLessonIsActive ? Colors.GREEN : Colors.GREY,
									transform: "scaleX(1.2)",
								}}
							/>
						</ST.LeftRightButton>
					</ST.LeftRightButtons>
				</ST.VideoContainer>

				<ST.InfoContainer>
					<ST.InfoModule id="ModuleTile">
						{/* убирается на 320 - 768 */}
						<ST.res320_768Del>
							<ST.TitleContainer>
								<ST.InfoTitle id="badge module">
									<Typography
										variant="h5"
										sx={{ color: Colors.BLUE_015 }}
									>
										{dataGetMaterialEvents?.name}
									</Typography>
								</ST.InfoTitle>

								<ST.Baydges id="znachki">
									{dataGetMaterialEvents?.badges.map((badge) => (
										<ST.Baydge color={badge.color}>
											<Typography variant="body1">{badge.name}</Typography>
										</ST.Baydge>
									))}
								</ST.Baydges>
							</ST.TitleContainer>

							<ST.NameModule id={"NameModule"}>
								<Typography variant="body1">
									{dataGetMaterialEvents?.description}
								</Typography>
							</ST.NameModule>

							<Typography
								variant="subtitle2"
								sx={{ color: Colors.BLUE_015 }}
							>
								Доступ до: {formatDateToUTC(dataGetMaterialEvents?.accessDate)}
							</Typography>

							<ST.LineStrix />

							<ST.ProgressBar id="ProgressBar">
								<ST.TitleProgressBarContainer>
									<ST.TitleRowContainer>
										<Typography variant="body2">Пройдено уроков</Typography>
										<Typography
											variant="subtitle2"
											sx={{ color: Colors.GREEN }}
										>
											&nbsp;{allEndLessons} из {totalLessons}
										</Typography>
									</ST.TitleRowContainer>
								</ST.TitleProgressBarContainer>
								<Box sx={{ width: "100%", mt: 1, position: "relative" }}>
									<LinearProgress
										variant="determinate"
										value={progressPercentage}
										sx={{
											height: "20px",
											borderRadius: "4px",
											position: "relative",
										}}
									/>
									<Typography
										variant="subtitle2"
										sx={{
											color: Colors.WHITE,
											position: "absolute",
											top: "50%",
											left:
												progressPercentage === 0
													? `24px`
													: `${progressPercentage}%`,
											transform: "translate(-100%, -50%)",
											paddingRight: progressPercentage === 0 ? "0px" : "8px",
										}}
									>
										&nbsp;{progressPercentage}%
									</Typography>
								</Box>
							</ST.ProgressBar>
						</ST.res320_768Del>

						<ST.Lessons id="Lessons">
							<ST.LessonsFilters>
								<ST.TicTacFilter
									onClick={() => handleFilterChange("all")}
									selected={filter === "all"}
								>
									<Typography variant="body1">Все</Typography>
								</ST.TicTacFilter>
								<ST.TicTacFilter
									onClick={() => handleFilterChange("done")}
									selected={filter === "done"}
								>
									<Typography variant="body1">Пройденные</Typography>
								</ST.TicTacFilter>
								<ST.TicTacFilter
									onClick={() => handleFilterChange("notDone")}
									selected={filter === "notDone"}
								>
									<Typography variant="body1">Непройденные</Typography>
								</ST.TicTacFilter>
							</ST.LessonsFilters>

							<ST.LessonsList id="LessonsList">
								{/* dataGetMaterialEvents?.lessons */}
								{filteredLessons?.map((lesson, index) => {
									// для фильтра числа
									const lessonIndex =
										dataGetMaterialEvents?.lessons.findIndex(
											(l) => l.id === lesson.id
										) ?? -1;
									const selectLesson =
										lessonIndex !== -1 && currentLessonIndex === lessonIndex;

									return (
										<ST.Lesson
											key={lesson.id}
											selectLesson={selectLesson}
											onClick={
												lesson.active && lessonIndex != null
													? (event) =>
															handleClickLesson(event, lessonIndex, false)
													: undefined
											}
										>
											<ST.LessonName>
												<ST.GreenIcon activeLesson={lesson.active}>
													{lesson.isDone ? (
														<CheckIcon fontSize="small" />
													) : (
														<Typography
															variant="body1"
															sx={{ color: Colors.WHITE }}
														>
															{(lessonIndex ?? 0) + 1}
															{/* {index + 1} */}
														</Typography>
													)}
												</ST.GreenIcon>

												<Typography
													variant="body1"
													sx={{
														whiteSpace: "nowrap",
														overflow: "hidden",
														textOverflow: "ellipsis",
													}}
												>
													{lesson.name}
												</Typography>
											</ST.LessonName>
											{!lesson.active && <LessonLockIcon />}
										</ST.Lesson>
									);
								})}

								{/* если доступ открыт - показать приватСписок */}
								{isAccessVipLesson && (
									<ST.LessonsListPrivate id="LessonsListPrivate">
										<ST.LessonPrivateName>
											<Typography variant="body1">Закрытый доступ</Typography>
											<LessonLockIcon />
										</ST.LessonPrivateName>
										{/* dataGetMaterialEvents?.privateAccessLessons */}
										{filteredPrivateLessons?.map((privateLesson, index) => {
											const privateLessonIndex =
												dataGetMaterialEvents?.privateAccessLessons.findIndex(
													(l) => l.id === privateLesson.id
												) ?? -1;

											const selectLesson =
												privateLessonIndex !== -1 &&
												currentPrivateLessonIndex === privateLessonIndex;

											return (
												<ST.LessonPrivate
													key={privateLesson.id}
													selectLesson={selectLesson}
													onClick={
														privateLesson.active
															? (event) => handleClickLesson(event, index, true)
															: undefined
													}
												>
													<ST.LessonNameTwo>
														<ST.GreenIconPrivate
															activeLesson={privateLesson.active}
														>
															{privateLesson?.isDone ? (
																<CheckIcon fontSize="small" />
															) : (
																<Typography
																	variant="body1"
																	sx={{ color: Colors.WHITE }}
																>
																	{index + 1}
																</Typography>
															)}
														</ST.GreenIconPrivate>
														<Typography
															variant="body1"
															sx={{
																whiteSpace: "nowrap",
																overflow: "hidden",
																textOverflow: "ellipsis",
															}}
														>
															{privateLesson.name}
														</Typography>
													</ST.LessonNameTwo>

													<ST.TitleRowContainer>
														<Typography variant="body2">Доступ до:</Typography>
														<Typography variant="subtitle2">
															&nbsp;
															{formatDateAndTimeToUTC(privateLesson.accessDate)}
														</Typography>
													</ST.TitleRowContainer>
												</ST.LessonPrivate>
											);
										})}
									</ST.LessonsListPrivate>
								)}
							</ST.LessonsList>
						</ST.Lessons>
					</ST.InfoModule>

					{hasAttestation && (
						<ST.InfoModule
							id="Attestation"
							sx={{ gap: "8px" }}
						>
							<ST.AttestationTitleContainer>
								<Typography variant="h5">Аттестация</Typography>

								{attestationCompleted ? (
									<ST.Baydge sx={{ backgroundColor: Colors.GREEN_LIGHT }}>
										<Typography
											variant="body1"
											sx={{ color: Colors.GREEN }}
										>
											Пройден
										</Typography>
									</ST.Baydge>
								) : (
									<ST.Baydge sx={{ backgroundColor: Colors.RED_LIGHT }}>
										<Typography
											variant="body1"
											sx={{ color: Colors.RED }}
										>
											Не пройден
										</Typography>
									</ST.Baydge>
								)}
							</ST.AttestationTitleContainer>
							<Typography variant="body2">
								Пройдите тестирование после модуля, чтобы закрепить знания
							</Typography>

							<ST.AttestationButton
								//@ts-ignore
								component={Link}
								to={attestationLink}
								sx={{ marginTop: "8px" }}
							>
								<Typography
									variant="body1"
									sx={{
										color: Colors.GREEN,
									}}
								>
									Перейти к тесту
								</Typography>
								<ArrowForwardIcon
									sx={{
										color: Colors.GREEN,
										transform: "scaleX(1.2)",
									}}
								/>
							</ST.AttestationButton>
						</ST.InfoModule>
					)}
				</ST.InfoContainer>
			</ST.VideoAndInfoContainer>
		</ST.MaterialEventContainer>
	) : null;
};

export default MaterialUser;
